<script setup lang="ts">
export type ActionIconName =
  'members' | 'bell' | 'advanced' | 'signOut' | 'plus' | 'star' | 'starFilled' | 'backup'

defineProps<{ name: ActionIconName }>()
</script>

<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-hidden="true"
    class="block shrink-0"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="butt"
    stroke-linejoin="miter"
  >
    <g v-if="name === 'members'">
      <circle cx="6" cy="5.5" r="2.5" />
      <path d="M1.5 13.5c0-2.5 2-4 4.5-4s4.5 1.5 4.5 4" />
      <path d="M10.5 3.2a2.5 2.5 0 0 1 0 4.6M12 9.8c1.6.5 2.5 1.7 2.5 3.7" />
    </g>
    <g v-else-if="name === 'bell'">
      <path d="M3.5 11.5V7a4.5 4.5 0 0 1 9 0v4.5l1 1.5h-11z" />
      <path d="M6.5 14.5h3" />
    </g>
    <g v-else-if="name === 'advanced'">
      <path d="M2 4h12M2 8h12M2 12h12" />
      <path d="M5 2.5v3M10.5 6.5v3M6.5 10.5v3" stroke-width="2.4" />
    </g>
    <g v-else-if="name === 'signOut'">
      <path d="M6.5 2.5h-4v11h4" />
      <path d="M6 8h8M11 5l3 3-3 3" />
    </g>
    <g v-else-if="name === 'plus'">
      <path d="M8 2.5v11M2.5 8h11" />
    </g>
    <g v-else-if="name === 'backup'">
      <rect x="2" y="2.5" width="12" height="3" rx="0.5" />
      <path d="M3 5.5v7.5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5.5" />
      <path d="M6.5 8.5h3" />
    </g>
    <path
      v-else-if="name === 'star'"
      d="m8 1.8 1.9 4.1 4.4.5-3.3 3 .9 4.4L8 11.6l-3.9 2.2.9-4.4-3.3-3 4.4-.5z"
    />
    <path
      v-else
      fill="currentColor"
      d="m8 1.8 1.9 4.1 4.4.5-3.3 3 .9 4.4L8 11.6l-3.9 2.2.9-4.4-3.3-3 4.4-.5z"
    />
  </svg>
</template>
